<template>
  <div class="container-fluid">
    <b-card no-body>
      <b-tabs cards v-model="tabIndex">
        <b-tab title="Report Query">
          <template v-slot:title>
            <span style="color: black">Report Query</span>
            <b-btn variant="link" size="sm" class="my-0" href="#">.</b-btn>
          </template>
          <report-query
            @clicked="newTab"
            :mainCategory="mainCategory"
          ></report-query>
        </b-tab>
        <b-tab v-for="(i, index) in tabsArray" :key="'dyn-tab-' + i" active>
          <template v-slot:title>
            <span style="color: black">{{
              i + 1 + " " + tabsNames[index]
            }}</span>
            <b-btn
              variant="link"
              size="sm"
              class="my-0"
              @click.prevent="closeTab(i)"
              style="color: red"
              href="#"
              >X</b-btn
            >
          </template>
          <div class="row" style="margin: 0">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <!-- <b-button
                        class="float-right mx-3"
                        variant="outline-danger"
                        size="sm"
                        @click="convertToPdf(index)"
                        style="float:right; font-size:1em; font-color:red"
                      >
                        PDF
              </b-button>-->
              <!-- <b-button
                        variant="outline-success"
                        size="sm"
                        @click="downloadExcel(index)"
                        style="float:right; font-size:1em; font-color:green"
                      >
                        Excel
              </b-button>-->
              <b-button
                variant="danger"
                small
                style="float: right; margin-bottom: 10px; margin-left: 10px"
                v-on:click="convertToPdf(index)"
                >PDF</b-button
              >
              <json-excel
                :data="itemsArray[index]"
                :header="headerArray[index]"
                :stringifyLongNum="stringifylong"
                style="float: right"
              >
                <button
                  type="button"
                  style="float: right; margin-bottom: 10px"
                  class="btn btn-info waves-effect waves-light m-r-10"
                >
                  Excel
                </button>
              </json-excel>
            </div>
          </div>
          <loading
            :active.sync="isLoading"
            color="#5dbbda"
            loader="spinner"
            :is-full-page="fullPage"
            width:2
            height:2
          ></loading>

          <div class="row" style="margin-top: 10px">
            <div class="col-md-12">
              <div class="overflow-auto">
                <b-table
                  show-empty
                  selectable
                  select-mode="multi"
                  head-variant="dark"
                  empty-text="No records available."
                  stacked="md"
                  bordered
                  striped
                  style="font-size: 12px"
                  :items="itemsArray[index]"
                  :current-page="currentPage[index]"
                  :per-page="perPage[index]"
                  hover
                ></b-table>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-2">
              <span style="font-size: 0.875rem"
                >Total Rows: {{ totalRows[index] }}</span
              >
            </div>

            <div class="col-md-3">
              <b-form-group
                horizontal
                label="Per page"
                class="mb-0"
                label-size="sm"
                label-cols="3"
              >
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage[index]"
                  size="sm"
                />
              </b-form-group>
            </div>

            <div class="col-md-7">
              <b-pagination
                v-model="currentPage[index]"
                :total-rows="totalRows[index]"
                :per-page="perPage[index]"
                size="sm"
                style="float: right; margin-top: 0"
                limit="10"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// import { BIcon, BIconXCircle } from "bootstrap-vue";
import ReportQuery from "./ReportsQuery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
//import XLSX from "xlsx";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
// const base_url = process.env.VUE_APP_BASE_URL;

export default {
  components: { ReportQuery, JsonExcel, Loading },
  props: ["mainCategory"],
  data() {
    return {
      stringifylong:true,
      header:
        "Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)",
      perPage: [],
      currentPage: [],
      pageOptions: [50, 100, 500],
      totalRows: [],
      tabIndex: 0,
      tabsArray: [],
      tabCounter: 0,
      tabsNames: [],
      itemsArray: [],
      headerArray: [],
      board_name: "",
      board_address1: "",
      board_address3: "",
      isLoading: false,
      fullPage: false,
    };
  },
  methods: {
    closeTab(x) {
      for (let i = 0; i < this.tabsArray.length; i++) {
        if (this.tabsArray[i] === x) {
          this.tabsNames.splice(i, 1);
          this.itemsArray.splice(i, 1);
          this.totalRows.splice(i, 1);
          this.perPage.splice(i, 1);
          this.currentPage.splice(i, 1);
          this.tabsArray.splice(i, 1);
          this.headerArray.splice(i, 1);
        }
      }
    },
    newTab() {
      this.isLoading = true;
      this.tabsArray.push(this.tabCounter++);

      this.tabsNames.push(this.$store.getters.getReportName);
      let hdr = [
        "Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)",
        this.$store.getters.getReportName,
      ];

      let rptqry = this.$store.getters.getReportQuery;
      if (rptqry.ReportID == 24 || rptqry.ReportID == 25) {
        if (rptqry.ReportFilter.financial_year) {
          hdr.push("Financial year : " + rptqry.ReportFilter.financial_year);
        }
      }
      hdr.push(" ");
      this.headerArray.push(hdr);
      let Promise = apis.GetReportDetails(rptqry);

      Promise.then((response) => {
        if (response.status == 200) {
          this.itemsArray.push(response.body);
          //this.itemsArray = response.data.data;
          this.totalRows.push(response.body.length);
          this.perPage.push(10);
          this.currentPage.push(1);
          this.tabIndex = this.tabsArray.length;
        }
        this.isLoading = false;
      }).catch((err) => {
        console.error(err);
        this.isLoading = false;
      });
      //this.itemsArray.push(this.customerInfo[i]);
    },
    convertToPdf(index) {
      var pdf = new jsPDF("l", "pt");
      var board_name =
        "Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)";

      pdf.setFontSize(14);
      pdf.text(board_name.toUpperCase(), pdf.internal.pageSize.width / 2, 30, {
        align: "center",
      });

      pdf.setFontSize(12);
      pdf.text(this.tabsNames[index], pdf.internal.pageSize.width / 2, 50, {
        align: "center",
      });
      // pdf.text(this.tabsNames[index], 250, 100);
      var vc = this;
      let rw = vc.itemsArray[index][0];
      let hdr = [];
      for (var x in rw) {
        hdr.push({ header: x, dataKey: x });
      }
      const addFooters = (pdf) => {
        const pageCount = pdf.internal.getNumberOfPages();

        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        for (var i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          pdf.text(
            "Page " + String(i) + " of " + String(pageCount),
            pdf.internal.pageSize.width / 2,
            580,
            {
              align: "center",
            }
          );
        }
      };

      pdf.autoTable({
        columns: hdr,
        startY: 70,
        body: vc.itemsArray[index],
      });
      addFooters(pdf);

      pdf.save("Report.pdf");
    },
    // downloadExcel(index) {
    //   let app_data = this.itemsArray[index];

    //   var vc = this;
    //   var wb = XLSX.utils.book_new();
    //   var ws = XLSX.utils.json_to_sheet(app_data);

    //   XLSX.utils.book_append_sheet(wb, ws, "Applications");
    //   XLSX.writeFile(wb, "report.xlsx");
    // }
  },

  mounted() {
    //this.get_board_details();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ReportViewer/ReportViewer.vue